<template>
  <v-autocomplete
    v-model="selectedPremise"
    :items="fullPremisesList"
    item-title="name"
    item-value="name"
    label="Gebäude/Etage"
    density="compact"
    class="dropDownMenu"
    variant="solo"
    hide-details
  />
</template>

<script>
export default {
  props: {
    modelValue: { type: String, default: '' },
    dropDownFavResLoc: { type: Array, default: () => [] }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      selectedPremise: this.modelValue || 'Alle'
    }
  },

  computed: {
    fullPremisesList() {
      const list = Array.isArray(this.dropDownFavResLoc)
        ? this.dropDownFavResLoc
        : []
      return [{ name: 'Alle', shortPrem: 'Alle' }, ...list]
    }
  },

  watch: {
    modelValue(val) {
      this.selectedPremise = val || 'Alle'
    },

    selectedPremise(val) {
      this.$emit('update:modelValue', val)
    }
  }
}
</script>

<style scoped>
.v-autocomplete {
  color: black;
  background-color: white;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
  border-radius: 16px;
  font-size: xx-small;
  width: 225px;
}
</style>
